import { ADDRESS_STORE_NAME } from 'Address/constants/store'
import { addressFactory } from 'Address/redux/addressStore'
import { Entity } from 'common/utils/Entity'

export const AddressSchema = new Entity(
  ADDRESS_STORE_NAME,
  {},
  { idAttribute: 'hash', afterStrategy: addressFactory }
)
